/**
 * Single source of truth for the human-readable label shown in the billing
 * "Type" column across every owner- and admin-facing billing surface.
 *
 * Precedence mirrors the admin RegistrationBillingForm exactly: `full` must win
 * over `single_payment`, because a paid-in-full plan can still carry the
 * registration-level `single_payment` flag (BillingScheduleResource derives that
 * flag independently of the per-row payment_type).
 */
export interface BillingTypeLabelRecord {
  payment_type?: string | null
  single_payment?: boolean | null
}

export const getBillingTypeLabel = (record: BillingTypeLabelRecord): string => {
  if (record.payment_type === 'complimentary') {
    return 'Complimentary'
  }
  if (record.payment_type === 'full') {
    return 'Full Payment'
  }
  if (record.single_payment) {
    return 'One Time Payment'
  }
  if (record.payment_type === 'adhoc') {
    return 'AdHoc'
  }
  if (record.payment_type === 'deposit') {
    return 'Deposit'
  }
  return 'Installment'
}
